import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const SamsaraRegistration = lazyLoader(
  () =>
    import(
      "Containers/SamsaraIntegration/SamsaraRegistration/SamsaraRegistration"
    )
);

export const SamsaraRegistrationPage = () => {
  return (
    <Layout>
      <SamsaraRegistration />
    </Layout>
  );
};
